module.exports = __webpack_public_path__ + "img/circle-arrow-down-right.2d0b96a6.svg";